import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { Observable } from 'rxjs';

interface Subscription {
  Enabled: boolean;
  NotificationEventId: number;
  NotificationTypeId: number;
  SubscriptionStateId: number;
  Visible: boolean;
}

@Injectable()
export class SubscribeService extends ServiceBase {
  serviceUrl = 'SubscribeService.svc';

  getEnabledSubscriptions(
    siteId: number,
    userName: string,
    force?: boolean,
  ): Observable<OrigamiResponse<Subscription[]>> {
    return this.origamiPost('/GetEnabledSubscriptions', { siteId, userName }, null, null, force);
  }

  getUserSubscriptions(siteId: number, userName: string, force?: boolean): Observable<any> {
    return this.origamiPost('/GetUserSubscriptions', { siteId, userName }, null, null, force);
  }

  createSubscription(body): Observable<any> {
    return this.origamiPost('/CreateSubscription', body, null, null, true);
  }
}
